import { useSelector } from "react-redux";
import FacilityRoleAccordion from "../../../components/UI/Accordion/FacilityRoleAccordion/FacilityRoleAccordion";
import Strings from "../../../resources/Strings";
import Details from "./Details";
import classes from "./Details.module.css";
import { getSortedUserScopes } from "../../../utils/UsersUtils";

const GmtDetails = (props) => {
  //const allowedUserSites = props?.userSitesByScopes.filter((site)=> props?.scopes.map((scope)=>scope.id)?.includes(site.scopeId));
  //const allowedUserSites = props?.userSitesByScopes.filter((site)=> props?.userScopes.filter(userScope => userScope.role.name !== ROLES_NAMES.CUSTOMER).map((userScope)=>userScope.scopeId)?.includes(site.scopeId));
  const sites = useSelector((state) => state.user.sites);
  const userScopes = getSortedUserScopes(sites, props?.userScopes);
  
  return (
    <Details {...props}>
      {!props?.isChargeAccount && (
       <>
        <span className={classes.subTitle}>
          {Strings.USER_INFO.FACILITIES_AND_ROLES}
        </span>
        <div className={classes.detailsAccordion}>
          {userScopes?.map((userScope) => (
            <div className={classes.summaryAccordion} key={userScope?.scopeId}>
              <FacilityRoleAccordion
                // key={site.id}
                scope={userScope?.scope} // site
                {...props}
                isViewMode={props.isViewMode}
              ></FacilityRoleAccordion> 
            </div>
          ))}
        </div>
       </>
      )}   
    </Details>
  );
};

export default GmtDetails;
